document.addEventListener('DOMContentLoaded', function () {
  var stage = document.querySelector('[data-ghips-bagstory]');
  if (!stage) return;

  var targets = ['potatoes', 'ghee'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var lines = {};
  var arrowheads = {};
  targets.forEach(function (name) {
    var line = stage.querySelector('.ghips-bagstory__line--' + name);
    if (!line) return;
    lines[name] = line;
    arrowheads[name] = stage.querySelector('.ghips-bagstory__arrowhead--' + name);
    var length = line.getTotalLength();
    line.style.strokeDasharray = length;
    line.style.strokeDashoffset = reduceMotion ? 0 : length;
  });

  function reveal(name) {
    stage.classList.add('reveal-' + name);
    if (lines[name]) lines[name].style.strokeDashoffset = 0;
    if (arrowheads[name]) arrowheads[name].style.opacity = 1;
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    targets.forEach(reveal);
    return;
  }

  // Each threshold crossed as the section scrolls further into view reveals
  // one more card, rather than one threshold firing both at once.
  var steps = [
    { ratio: 0.25, name: 'potatoes' },
    { ratio: 0.55, name: 'ghee' }
  ];

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        steps.forEach(function (step) {
          if (entry.intersectionRatio >= step.ratio) reveal(step.name);
        });
        if (entry.intersectionRatio >= steps[steps.length - 1].ratio) {
          observer.disconnect();
        }
      });
    },
    { threshold: steps.map(function (step) { return step.ratio; }) }
  );

  observer.observe(stage);
});
